module.exports = __webpack_public_path__ + "img/general-banking.8d60ea0.webp";